import { Check, ListFilter } from "lucide-react";
import { Filter } from "@/shared/lib/filter/filter";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shared/components/ui/popover";
import { Button } from "@/shared/components/ui/button";
import t from "@/lang/lang";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/shared/components/ui/command";
import { cn } from "@/shared/lib/utils";
import {
  CommitmentStatus,
  CommitmentStatusList,
} from "@/services/backend/relationships/types/relationship";

export interface CommitmentStatusFilterProps {
  filter: Filter<CommitmentStatus> | undefined;
  onFilterChange: (filter: Filter<CommitmentStatus>) => void;
  hidden?: boolean;
}

export function CommitmentStatusFilter({
  filter,
  onFilterChange,
  hidden = false,
}: CommitmentStatusFilterProps) {
  // This allows us to accept undefined filters,
  // which is common in list requests. This makes
  // it nicer to call the component.
  const filterVal = filter ?? { active: false, values: [] };
  // simplifies some code below
  const currentValues = filterVal.values ?? [];

  if (hidden) {
    return null;
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm">
          <ListFilter />
          {t("Status")}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0" align="start">
        <Command>
          <CommandInput placeholder={t("Status")} />
          <CommandList>
            <CommandEmpty className="py-3 text-center text-sm">
              {t("Status nicht gefunden")}
            </CommandEmpty>
            <CommandGroup>
              {CommitmentStatusList.map((commitmentStatus) => (
                <CommandItem
                  key={commitmentStatus}
                  value={commitmentStatus}
                  onSelect={() => {
                    const values = currentValues.includes(commitmentStatus)
                      ? currentValues.filter((v) => v !== commitmentStatus)
                      : [...currentValues, commitmentStatus];
                    onFilterChange({
                      active: values.length > 0,
                      values,
                    });
                  }}
                >
                  <Check
                    className={cn(
                      "mr-2 h-4 w-4",
                      currentValues.includes(commitmentStatus)
                        ? "opacity-100"
                        : "opacity-0",
                    )}
                  />
                  {t(commitmentStatus)}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
